import React from "react";
import {
  Modal,
  ModalHeader,
  ModalProps,
} from "@sonder/ui/source/styled/components/Modal";
import { ModalFooter } from "@sonder/ui/source/styled/fragments/Modal";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { useUpdateTask } from "core/queries/UpdateTask";
import { TaskStatus } from "typings/globalGQLTypes";

interface UnscheduleTaskModal extends Omit<ModalProps, "children"> {
  taskId: string;
}

export const UnscheduleTaskModal = ({
  isOpen,
  onClose,
  taskId,
}: UnscheduleTaskModal) => {
  const [onUpdateTask, { loading: isUpdating }] = useUpdateTask({
    onCompleted: () => {
      if (onClose) onClose();
    },
    refetchQueries: ["GetSchedulerMetrics"],
  });
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {({ closeModal }) => (
        <>
          <ModalHeader title="Unschedule Task" onClose={closeModal} />
          <p>Are you sure you want to unschedule this task?</p>
          <p>
            The cleaner(s) will receive an email notifying them that their
            cleaning has been cancelled. Be sure to contact the cleaning manager
            if necessary.
          </p>
          <p>
            <b>Note: This cannot be undone!</b>
          </p>
          <ModalFooter>
            <PrimaryButton
              disabled={isUpdating || !taskId}
              onClick={() => {
                if (taskId)
                  onUpdateTask({
                    variables: {
                      assigneeId: null,
                      dueBy: null,
                      newScheduledStartAt: null,
                      status: TaskStatus.ready,
                      taskId,
                    },
                  });
              }}
            >
              I&apos;m sure
            </PrimaryButton>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};
